<template>
  <div><iframe id="pdf" style="width: 100%; height: 100%"></iframe></div>
</template>

<script>
export default {
  name: "PDFPage",
};
</script>

<style lang="scss" scoped></style>
